/**
 * External dependencies
 */
import React, { useState } from "react";
import { connect } from "react-redux";
import { Box } from "@towersystems/towersystems-design-system";
import classnames from "classnames";

/**
 * Internal dependencies
 */
import { editReport } from "state/reports/actions";
import { getBuilderReportId } from "state/ui/report-builder/selectors";
import { getEditedReport } from "state/reports/selectors";
import FormTextInput from "components/forms/form-text-input";
import Icon from "components/icon";

/**
 * Style dependencies
 */
import "./styles.scss";

const EditReportName = ({ name, reportId, ...props }) => {
  const [value, setValue] = useState(name || "");
  const [focused, setFocused] = useState(false);

  const handleOnChange = (e) => {
    setValue(e.target.value);
  };

  const handleOnBlur = () => {
    props.editReport(reportId, { name: value });
    setFocused(false);
  };

  const classes = classnames("report-builder__report-name", {
    "is-focused": focused,
  });

  return (
    <Box className={classes}>
      <FormTextInput
        className="report-builder__report-name__input"
        onClick={() => setFocused(true)}
        onBlur={handleOnBlur}
        value={value}
        onChange={handleOnChange}
        style={{ width: value.length * 7.5 + 70 }}
      />
      <Box className="report-builder__report-name__icon">
        <Icon name="TiPencil" size="20" />
      </Box>
    </Box>
  );
};

export default connect(
  (state) => {
    let reportId = getBuilderReportId(state);
    let report = getEditedReport(state, reportId);

    return {
      reportId,
      name: (report && report.name) || "",
    };
  },
  { editReport }
)(EditReportName);
